export default "__VITE_ASSET__C8NuQb33__"